import { StyleSheet } from 'react-native';
import { sharedStyles } from '../RecordingItem/RecordingItem.jss';

const baseStyles = {
    ...sharedStyles,
    groupMetaContainer: {
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100%',
        flexDirection: 'row',
        backgroundColor: '#00000060'
    },
    groupMetaContainerOpen: {
        backgroundColor: 'transparent'
    },
    openRow: {
        backgroundColor: '#ffffff10'
    },
    textArea: {
        ...sharedStyles.textArea,
        alignSelf: 'stretch',
        alignItems: 'stretch'
    },
    dropDown: {
        marginLeft: -8,
        marginTop: 21
    },
    dropdownArrowDownStyle: {
        transform: [{ rotate: '-90deg' }]
    }
};

export default StyleSheet.create(baseStyles);
